import styled from "styled-components";
import RankingItem from "../rank/RankingItem";

const PastRankingList = ({rankData, gender, year, month}) => {
    console.log(rankData);
    const genderFilteredData = rankData[gender];
    return (
        <RankingListWrapper>
            {genderFilteredData.map(( list ) => (
                <RankingItem list={list} key={list.id} propsLength={"three"} year={year} month={month}/>
            ))}
        </RankingListWrapper>
    )
}

export default PastRankingList;

const RankingListWrapper = styled.ul`
  width: 100%;
  margin: 16px 0;
  background-color: #fff;
`;